export default __webpack_public_path__ + "static/media/info-modal-error.095b70e1.svg";